export default ({ i18n }) => ({
  DUE_DATE_INFO: i18n.t`Assignment Modal - Due date info`
});
  